import React from 'react';

const CastaicFooter = () => {
    return (
        <div className={'CastaicFooter'}>
            <div>Castaic Animal Care Center</div>
            <div>31044 Charlie Canyon Rd.</div>
            <div>Castaic, CA 91384</div>
            <div>(661) 257-3191</div>
        </div>
    );
};

export default CastaicFooter;
